import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import { Input } from 'semantic-ui-react'
import '../card.css';
import axios from 'axios';
import i18n from '../i18n';
import {connect} from 'react-redux';
import {reactLocalStorage} from 'reactjs-localstorage';
import Menutest from './menu.js';
import Modal from 'react-modal';
import { Button } from 'semantic-ui-react'
import { Table } from 'reactstrap';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import { API_BASE_URL } from "../utils/endpoints";

var groupOptions = []
const formData = new FormData();

  const customStylesstop = {
    content : {
      width               : '40%',
      marginRight         : '30%',
      marginLeft          : '30%',
      height              :'231px',
      marginTop           :'6%',
      background          :' #fcfcfc !important'
    }
  };
var total_success,total_failed=0;
class ImportContact extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            uploadfile: [],
            products: [
                { label: "Foo", value: 1 },
                { label: "Bar", value: 2 },
                { label: "Baz", value: 3 },
                { label: "Fuz", value: 4 },
            ],
            selectedValues: [],
            dataresult:[],
            modalIsOpen: false,
            show:false,
            collapsed: false,
             collapseID : '',
             options_sender:[],
             isArabic:false
        }
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    openModal() {
        this.setState({modalIsOpen: true});
      }

      afterOpenModal() {
        this.subtitle.style.color = '#f00';
      }

      closeModal() {
        this.setState({modalIsOpen: false});
        window.location="contact";
      }

    onChange(values) {
      const newArr = this.state.selectedValues;
        newArr.push(values);
        this.setState({
            selectedValues: newArr
        })
    }

    onChangegroup= event =>{

   const newArray = this.state.options_senders;
   var i;
   for(i=0;i<event.length;i++)
     {
       if(newArray.includes(event[i].value) === false){
         newArray.push(event[i].value);
             }
           }
 this.setState({selectedValues: newArray}, function () {
 });
}



    componentDidMount() {
      var token=reactLocalStorage.get('accessToken');
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
       apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllGroups/0";
      }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllGroups/0";
      }


      var headers = {'Content-Type': 'application/json', 'token' :token }
   axios.get(apiBaseUrl,{headers: headers})
       .then(res => {

         if(res.data != undefined)
           {
             const dataoption=res.data.result.groups;
             var length=res.data.result.groups.length;
             var i;
            const newArr = this.state.options_sender;
             for(i=0;i<length;i++)
            {
              var value_option=dataoption[i].group_name;
          newArr.push({
                 label: value_option,
                 value:dataoption[i].group_id
             });

             }
             groupOptions= newArr;
         }

        })
        var lang=i18n.language;
        if(lang ==="ar")
        {
          this.setState({isArabic:true})


        }
    }








    handleChange = event => {
        event.preventDefault();
        const newArr = this.state.uploadfile;
        newArr.push(event.target.files[0]);
        this.setState({
            uploadfile: newArr
        })


        formData.append('file', event.target.files[0]);
    }

    handleSubmit = event => {
        event.preventDefault();

     
        document.getElementById("contact_import_btn").disabled = true;
        document.getElementById("contact_import_btn").innerHTML = i18n.t("upload_in_progress.label");
        document.getElementById("contact_import_btn").style = 'color:white;font-weight:bold;border-radius: 15px;white-space: pre;line-height: 2.5;';

        var x = this;
        var token=reactLocalStorage.get('accessToken');
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
          apiBaseUrl = API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/importContact";
        }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/importContact";
        }


         var data=formData;
          var headers = {
           'Content-Type': 'multipart/form-data',
           'token':token
            }
          axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
          {
          if(response.status === 200)
          {
            if(response.data.result != undefined && response.data.status =='success')
            {
             x.setState({ dataresult :response.data.result.imported_contacts_report });
             total_success=response.data.result.imported_contacts_success;
             total_failed=response.data.result.imported_contacts_failed;
             x.setState({modalIsOpen: true});
            }

       if(response.data.status =='failed')
       {
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:response.data.result.result,
          animation: 'bounce',
          time: 5000,

      });
      document.getElementById("contact_import_btn").disabled = false;
      document.getElementById("contact_import_btn").innerHTML = i18n.t("Submit.label");
       }


          }
          else if(response.status === 204 ){
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
        document.getElementById("contact_import_btn").disabled = false;
        document.getElementById("contact_import_btn").innerHTML = i18n.t("Submit.label");


          }
          else{
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
        document.getElementById("contact_import_btn").disabled = false;
        document.getElementById("contact_import_btn").innerHTML = i18n.t("Submit.label");

          }
          })
          .catch(function (error) {
          console.log(error);
          });


    }

    back = () => {
        window.location="contact";

    }
    render() {
        return (
            <div className="big_div">
            <Menutest/>
            <div className="actionMenu">

            <div className="add_form">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="6">
                            <MDBCard className="add_card">
                                <MDBCardBody>
                                    <form onSubmit={this.handleSubmit}>

                                        <p className="h4 text-center py-4 text_style darked_color">{i18n.t('Import.label')}</p>
                                  <br />
                                        <br />

                                        <a style={{float : this.state.isArabic ? 'right' :''}} href={require('../pictures/sample.csv')} download style={{fontSize:'15px',fontWeight:'bold',paddingLeft: '13px',color: 'red',cursor:'pointer'}}>{i18n.t('Click_to_download_sample.label')}</a>
                                        <br/> <br/>

                                          <div style={{textAlign : this.state.isArabic ? 'initial' :''}}>
                                        <Input
                                            type="file"
                                            ref={(input) => { this.filesInput = input }}
                                            name="file"
                                            className='import_file'
                                           style={{paddingLeft:'0px'}}
                                            iconPosition={this.state.isArabic? 'right' :'left'}
                                            label={i18n.t('UploadCSV.label')}
                                            labelPosition={this.state.isArabic? 'left' :'right'}
                                            placeholder={i18n.t('UploadCSV.label')}
                                            onChange={this.handleChange}
                                        />
                                    </div>

                                        <div className="text-center py-4 mt-3">
                                            <Button className="submit_btn_darked" style={{borderRadius:'15px'}}>

                                                <MDBBtn color="cyan" onClick={this.back}>
                                                {i18n.t('Back.label')}
                    </MDBBtn>
                                            </Button>

                                            <Button className="submit_btn_darked" id="contact_import_btn" style={{borderRadius:'15px'}}>
                                                <MDBBtn color="cyan" type="submit">
{i18n.t('Submit.label')}                    </MDBBtn>
                                            </Button>

                                        </div>
                                    </form>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </div>


            <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStylesstop}
                            contentLabel="Example Modal"
                            className="stop_modal"
>
<i class="close icon" onClick={this.closeModal}></i>
<h2 ref={subtitle => this.subtitle = subtitle} className="report_title_stop">{i18n.t('Details.label')}</h2>
  <br/>
  <div className="">
  <div>
  <Table celled inverted selectable style={{ width: '60%', marginLeft: '20%'}}>
  <thead>
          <tr>
        <th>{i18n.t('total_success.label')}</th>
        <th>{i18n.t('total_failed.label')}</th>

      </tr>
    </thead>

    <tbody>

       <tr>

         <td>{total_success}</td>
        <td>{total_failed}</td>


        </tr>



    </tbody>
  </Table>



  </div>
  </div>


</Modal>
            </div>
            </div>
        );
    }
};
const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps)(ImportContact);